import api from 'api';

const SCHEMA = 'http';

type ErrorType = {
    message: string;
    [x: string]: unknown;
};

export async function get(
    apiPath: string,
    successCallback: (data: any) => any,
    failCallback: (errors: ErrorType[]) => any,
    accessToken = ''
) {
    // const delimiter = apiPath.startsWith('/') ? '' : '/';
    // const hostName = process.env.REACT_APP_BACKEND_HOST
    // const portNumber = process.env.REACT_APP_BACKEND_PORT
    try {
        let response = await fetch(apiPath, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        
        let jsonData;
        try {
            jsonData = await response.json();
        } catch (e) {
            return failCallback([{ message: `Failed to parse response. Status: ${response.status}` }]);
        }

        const { data, errors = [] } = jsonData;
        if (data) successCallback(data);
        else if (errors && errors.length > 0) failCallback(errors);
        else if (!response.ok) failCallback([{ message: `HTTP Error ${response.status}` }]);
    } catch (e: any) {
        failCallback([{ message: e?.message || 'Network request failed' }]);
    }
}

export async function getFile(
    apiPath: string,
    successCallback: (data: any) => any,
    failCallback: (errors: any) => any,
    accessToken = ''
) {
    try {
        let response = await fetch(apiPath, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        const fileData = await response.blob();
        if (fileData) successCallback(fileData);
    } catch (e) {
        failCallback([e]);
        return;
    }
}

export async function post(
    apiPath: string,
    payload: any,
    successCallback: (data: any) => any,
    failCallback: (errors: any) => any,
    accessToken = ''
) {
    // const delimiter = apiPath.startsWith('/') ? '' : '/';
    // const hostName = process.env.REACT_APP_BACKEND_HOST
    // const portNumber = process.env.REACT_APP_BACKEND_PORT
    // let url = `${SCHEMA}://${hostName}:${portNumber}${delimiter}${apiPath}`;
    try {
        let response = await fetch(apiPath, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(payload),
        });

        let jsonData;
        try {
            jsonData = await response.json();
        } catch (e) {
            return failCallback([{ message: `Failed to parse response. Status: ${response.status}` }]);
        }

        const { data, errors = [] } = jsonData;
        if (data) successCallback(data);
        else if (errors && errors.length > 0) failCallback(errors);
        else if (!response.ok) failCallback([{ message: `HTTP Error ${response.status}` }]);
    } catch (e: any) {
        failCallback([{ message: e?.message || 'Network request failed' }]);
    }
}
